// extracted by mini-css-extract-plugin
export default {"description":"style_description__Bn8Bq","fade-in":"style_fade-in__G2b91","top":"style_top__K4P+7","image":"style_image__vwfwU"};